import { render, staticRenderFns } from "./OverviewMixChart.vue?vue&type=template&id=267e2228&"
import script from "./OverviewMixChart.vue?vue&type=script&lang=js&"
export * from "./OverviewMixChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('267e2228')) {
      api.createRecord('267e2228', component.options)
    } else {
      api.reload('267e2228', component.options)
    }
    module.hot.accept("./OverviewMixChart.vue?vue&type=template&id=267e2228&", function () {
      api.rerender('267e2228', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/dashboard/purchase-activity/OverviewMixChart.vue"
export default component.exports